import React from "react";
import { useIsFetching } from "react-query";
import { useSelector } from "react-redux";
import styled from "styled-components";
import BREAKPOINTS from "../../constants/breakpoints";
import { getCurrentUser } from "../../store/slices/auth";
import Loading from "../ui/Loading";
import NavTopLeagueLinks from "./NavTopLeagueLinks";
import NavTopUserLinks from "./NavTopUserLinks";

const StyledNavTopContainerDiv = styled.div`
  background: ${(props) => props.theme.colors.navBgMain()};
  box-shadow: 0 0 20px ${(props) => props.theme.colors.boxShadow};
  position: relative;
  width: 100%;
  z-index: 200;

  & a {
    padding: 0.5rem;
  }
`;

const StyledNavTopDiv = styled.div`
  max-width: ${(props) => props.theme.sizes.pageWidth};
  margin: 0 auto;
`;

const StyledNavTopUl = styled.ul`
  height: 2.5rem;
`;

const StyledBurgerLi = styled.li`
  display: block;

  @media (min-width: ${BREAKPOINTS.md}px) {
    display: none;
  }

  & > button {
    border: 0;
    background: none;
    color: inherit;
    padding: 0.5rem;
  }

  & > button:focus {
    outline: 0;
  }
`;

const NavTop = (props) => {
  const isFetching = useIsFetching();
  const currentUser = useSelector(getCurrentUser);
  const { toggleNavSideOn } = props;

  const bgFetching = isFetching ? <Loading /> : null;

  return (
    <StyledNavTopContainerDiv>
      <StyledNavTopDiv>
        <StyledNavTopUl className={"flex"}>
          <StyledBurgerLi onClick={toggleNavSideOn}>
            <button type={"button"}>menu</button>
          </StyledBurgerLi>
          {currentUser.isLoggedIn && <NavTopLeagueLinks />}
          {bgFetching}
          <NavTopUserLinks />
        </StyledNavTopUl>
      </StyledNavTopDiv>
    </StyledNavTopContainerDiv>
  );
};

export default NavTop;
